

<template>
  <div
    class="enum-value-item"
  >
    <div class="enum-value-item_hd">
      <div class="enum-value-item_lt">
        {{ enumData.Name }} ({{ maxText }})
      </div>
      <div class="enum-value-item_lt">
        <el-dropdown
          v-if="enumData.iftttList && enumData.iftttList.length < 3"
          trigger="click"
          class="dialog_add text-button"
          @command="handleAddSet"
        >
          <span class="el-dropdown-link">
            {{ $t('iftttset.adddata') }}
            <i class="el-icon-arrow-down el-icon--right" />
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in options"
              :key="index"
              :command="item.value"
            >
              {{ item.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <div class="enum-value-item_bd">
      <ul class="enum-value-item_actionList">
        <li
          v-for="(item, index) in enumData.iftttList"
          :key="index"
          class="enum-value-item_actionItem"
        >
          <div
            class="enum-value-item_actionItem-lt"
          >
            <em>{{ index + 1 }}</em> {{ item.IFT_Name }}
          </div>
          <div
            class="enum-value-item_actionItem-gt"
          >
            <div
              class="enum-value-item_actionItem_control"
              @click="() => handlerEdit(item)"
            >
              <i class="icon-21" />
            </div>
            <div
              class="enum-value-item_actionItem_control"
              @click="() => handlerDelete(item)"
            >
              <i class="icon--1" />
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>

export default {
  components: { 
  },
  props: {
    enumData: {
      type: Object,
      default: () => ({})
    },
    triggerData: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      visible: false,
      options: [
        {
          value: 1,
          label: this.$t('iftttset.doswitchifttt')
        },
        {
          value: 2,
          label: this.$t('iftttset.doscene')
        },
        {
          value: 3,
          label: this.$t('iftttset.areacontrol')
        },
        {
          value: 4,
          label: this.$t('iftttset.device')
        },
        {
          value: 5,
          label: this.$t('iftttset.delay')
        }
      ],
      maxText: this.$t('ifttt.createUp3').replace(/\${{n}}/, 3)
    }
  },

  watch: {
  },

  mounted(){
    // console.log('enumData', this.enumData, this.triggerData);
    const recommendations = this.triggerData?.UI?.recommendations || [];
    // this.options = recommendations.map(item => {
    //   return {
    //     value: item.templateID,
    //     label: item.name
    //   }
    // }).concat([{
    //   value: 6,
    //   label: '开'
    // }, {
    //   value: 7,
    //   label: '关'
    // }]);
    this.options = [
      {
        label: this.$t('iftttset.customize'),
        value: -1
      },
      {
        value: 6,
        label: this.$t('ifttt.open')
      }, 
      {
        value: 7,
        label: this.$t('ifttt.close')
      }
    ];
  },

  created() {
  },

  methods: {
    handleAddSet (command) {
      this.$emit('enumClick', command);
      // if (command == 'a') {
      //   if (this.triggermanual.length == 0) {
      //     this.dialogIfttt = true
      //     this.is_click = false
      //   } else {
      //     warning(this, this.$t('iftttset.nodoiftttwarning'))
      //   }
      // } else if (command == 'b') {
      //   this.dialogIfttt2 = true
      //   this.is_click = true
      //   this.checkShow = false
      // } else if (command == 'c') {
      //   // 场景弹出
      //   this.dialogVisible = true
      // } else if (command == 'd') {
      //   // action设备选择弹出
      //   this.dialogAction = true
      // } else if (command == 'e') {
      //   // 延时弹出

      //   this.value1 = '00'
      //   this.value2 = '00'
      //   this.value3 = '01'
      //   this.centerDialogVisible = true
      //   this.blueTittle = this.$t('iftttset.delayset')
      // } else if (command == 'f') {
      //   this.temparealist = []
      //   this.tempareacheckedarea = []
      //   // 区域选择弹出
      //   this.dialogAreaSelect = true
      //   this.tempareaactiontempListDefault()
      // } else if (command == 'h') {
      //   this.dialogHcl = true
      // }
    },

    handlerEdit(item) {
      this.$emit('editIfttt', item, this.enumData);
    },

    handlerDelete(item) {
      this.$emit('deleteIfttt', item);      
    }
  }
}
</script>

<style lang="scss" scoped>
.enum-value-item {

  &_hd {
    display: flex;
    justify-content: space-between;
  }

  &_actionItem {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    // padding: 10px 0;
    
    color: #333;
    cursor: pointer;

    &:not(:last-child) {
      border-bottom: 1px dashed #d6dce1;
    }

    &-gt {
      display: flex;
      align-items: center;
    }

    &_control {
      margin-left: 10px;
    }

    em {
      display: inline-block;
      margin-right: 12px;
      margin-left: 10px;
      width: 5px;
      height: 5px;
      font-size: 10px;
      border-radius: 50%;
      text-indent: -16px;
      background-color: #717171;
      line-height: 5px;
    }
  }
}
</style>
